import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { ROOT } from 'navigation/CONSTANTS';
import logo from 'assets/icons/Header/icon-logo.svg';
import scss from './Logo.module.scss';
const logoPath = `${logo}#logo`;
const LogoIcon = ({ logoClassName }) => (_jsx("svg", Object.assign({ className: `${scss.logoIcon} ${logoClassName ? logoClassName : ''}` }, { children: _jsx("use", { href: logoPath }) })));
export const Logo = ({ linkClassName, logoClassName }) => (_jsx(Link, Object.assign({ to: ROOT, className: `${scss.logoLink} ${linkClassName ? linkClassName : ''}` }, { children: _jsx(LogoIcon, { logoClassName: logoClassName }) })));
export const DrawerLogo = () => (_jsx(Link, Object.assign({ to: ROOT, className: scss.drawerLogoLink }, { children: _jsx(LogoIcon, {}) })));
